// «Помощь» союзников: участник альянса просит помочь со стройкой, исследованием или наймом,
// каждое нажатие союзника сокращает таймер. Сколько помощей принимает запрос — зависит от посольства.
export const ALLIANCE_HELP = {
  /** Помощей на запрос без посольства и прибавка за уровень посольства (не больше max). */
  base: 5,
  perEmbassyLevel: 1,
  max: 25,
  /** Одна помощь: pct% общего времени таймера, но не меньше minSec секунд. */
  pct: 1,
  minSec: 60,
  /** Награда помогающему (серебро) — за первые rewardedPerDay помощей в сутки. */
  rewardSilver: 50,
  rewardedPerDay: 30,
} as const;

export const HELP_KINDS = ['building', 'research', 'training'] as const;
export type HelpKind = (typeof HELP_KINDS)[number];

/** Сколько помощей примет запрос при данном уровне посольства. */
export function helpCapacity(embassyLevel: number): number {
  return Math.min(
    ALLIANCE_HELP.max,
    ALLIANCE_HELP.base + ALLIANCE_HELP.perEmbassyLevel * Math.max(0, embassyLevel),
  );
}

/** На сколько секунд одна помощь сокращает таймер общей длительностью totalSec. */
export function helpSeconds(totalSec: number): number {
  return Math.max(ALLIANCE_HELP.minSec, Math.round((totalSec * ALLIANCE_HELP.pct) / 100));
}
